import './ui/home.css';
import logo from '../imgs/logo.svg';

import flameOn from '../imgs/queezy.png';
import flameOff from '../imgs/streak.png';

import { useContext, useEffect, useState, useRef } from 'react';
import { defaults } from 'chart.js/auto';
import { Line } from 'react-chartjs-2';

import { ToggleOverlay, UserContext } from './contexts';
import { DevMode } from '../contexts';
import { title } from '../ui/helpers';
import { Button, IconBut } from '../ui/buttons';
import { Host } from '../App';
import { useLocation } from 'react-router-dom';


defaults.maintainAspectRatio = false;
defaults.responsive = true;


export default function Home() {
    const location = useLocation();
    const errMsg = location.state?.error;

    return (
        <div className="home view fw">
            <div className='content fw'>
                <Header />
                {
                    errMsg &&
                    <div className='alert fw alert-danger' style={{maxWidth: "500px"}}>
                        {errMsg}
                    </div>
                }
                <div>
                    <div style={{ margin: "20px 0", padding: "0 20px" }}>
                        <StreakCount />
                    </div>
                    <div style={{ margin: "20px 0", padding: "0 20px" }}>
                        <QuizDashboard />
                    </div>
                    <hr className='margin' style={{ width: "calc(100% - 40px)" }}></hr>
                    <div style={{ margin: "20px 0" }}>
                        <SetsPrev />
                    </div>
                    <hr className='margin' style={{ width: "calc(100% - 40px)" }}></hr>
                    <div style={{ margin: "20px 0" }}>
                        <QuizzesPrev />
                    </div>
                    <CreateButton />
                    <div style={{ width: "100%", height: "50px" }}></div>
                </div>
            </div>
        </div>
    )
}


function Header() {
    const User = useContext(UserContext);

    return (
        <header className="home-header fw">
            <div className='flex fw mid-align' style={{ justifyContent: 'space-between' }}>
                <div className='flex mid-align'>
                    <img src={logo} alt="LearnXcess Logo" />
                    <div style={{ textWrap: "nowrap" }}>Hi, {User.first_name}</div>
                </div>
                <div className='flex' style={{ gap: "15px" }}>
                    <IconBut className="fa-solid fa-sparkles" />
                    <IconBut className="fa-solid fa-bell" />
                </div>
            </div>
        </header>
    )
}


const chartDevData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
    datasets: [{
        label: 'My First Dataset',
        data: [65, 59, 80, 81, 56, 55, 40],
        fill: false,
        borderColor: 'rgb(75, 192, 192)',
        tension: 0.4
    }],
    success: true
};

export function QuizDashboard() {
    const [chartData, setChartData] = useState({});
    const chartRef = useRef(null);

    const devMode = useContext(DevMode);


    useEffect(() => {
        let ignore = false;

        if (devMode) {
            setChartData(chartDevData)

        } else {
            fetchEm()
                .then(res => res.json())
                .then(!ignore && setChartData)
                .catch(err => {
                    !ignore && setChartData({ error: err });
                    console.error(err)
                })
        }

        return () => {
            ignore = true;
        }
    }, [devMode, fetchEm])


    return (
        <div className="quiz-dash br-5 fw" style={{ backgroundColor: "var(--sec-col)" }}>
            <div className='content fw'>
                {
                    chartData.success ?
                        <Line
                            data={chartData}
                            options={{
                                elements: {
                                    line: {
                                        tension: 0.4
                                    }
                                }
                            }}
                            ref={chartRef}
                        />
                        :
                        <div className="max" style={{ padding: "10px" }}>
                            {
                                chartData.error ?
                                    <>
                                        <p>{chartData.error}</p>
                                        <Button onClick={reload}> Retry </Button>
                                    </>
                                    :
                                    <i className='fa-solid fa-spinner fa-spin fa-2xl'></i>
                            }
                        </div>
                }
            </div>
        </div>
    )


    function fetchEm() {
        return fetch(`${Host}/api/analytics`)
    }


    function reload() {
        fetchEm()
            .then(res => res.json(), err => {
                setChartData({ error: err })
            })
            .then(setChartData)
    }

}


export function StreakCount() {
    const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const [count, setCount] = useState();

    let cur = new Date().getDay();
    const days = DAYS.splice(cur).concat(DAYS.splice(0, cur));

    const devMode = useContext(DevMode), devData = 11;


    useEffect(() => {
        let ignore = false;

        if (devMode) {
            setCount(devData)

        } else {
            fetch(`${Host}/api/streak`)
                .then(res => res.json())
                .then(json => {
                    !ignore && setCount(json.count)
                })
                .catch(console.error)
        }


        return () => {
            ignore = true;
        }
    }, [devMode]);


    return (
        <div className="min-streak fw br-5" style={{ backgroundColor: "var(--sec-col)" }}>
            <div className="flex-col mid-align fw" style={{ gap: "10px" }}>
                <div className="flex mid-align fw" style={{ justifyContent: "space-between", padding: "10px" }}>
                    <span>Daily Streak</span>
                    <div>
                        {count ?
                            <div className="flex mid-align" style={{ gap: "5px" }}>
                                <div style={{ width: "1.5em", height: "1.5em" }}>
                                    <div className="max img-cover br-5" style={{ backgroundImage: `url(${flameOn})` }}></div>
                                </div>
                                <span>{count}</span>
                            </div>
                            :
                            <>
                                <span> loading </span>
                                <i className="fa-solid fa-spinner fa-spin"></i>
                            </>
                        }
                    </div>
                </div>
                <div className="flex mid-align fw" style={{ justifyContent: "space-evenly", padding: "10px" }}>
                    {
                        days.reverse().map((day, i) =>
                            <Flame key={day} burn={i < count} day={day} />
                        )
                    }
                </div>
            </div>
        </div>
    )


    function Flame({ burn, day }) {

        return (
            <div className="flex-col mid-align" style={{ gap: "5px" }}>
                <div style={{ width: "2em", height: "2em" }}>
                    <div className='max img-cover br-5' style={{ backgroundImage: `url(${burn ? flameOn : flameOff})` }} ></div>
                </div>
                <small> {title(day)} </small>
            </div>
        )
    }
}


// SETS PREVIEW
const setsDevData = [
    {
        id: "jbdvs",
        title: "Human  Evolution",
        size: 7
    },
    {
        id: "dknv",
        title: "Organic Chemistry",
        size: 14
    },
    {
        id: "lskdnvaskd",
        title: "Electric n Magnetic Feilds",
        size: 5
    }
]

function SetsPrev() {
    // can be a list (empty or not), undefined (loading), false(needs retrying)
    const [setList, setSetList] = useState();

    const devMode = useContext(DevMode);


    useEffect(() => {
        let ignore = false;

        if (devMode) {
            setSetList(setsDevData)

        } else {
            !setList && fetchEm()
                .then(res => res.json(), err => {
                    console.error(err)
                    !ignore && setSetList(false)
                })
                .then(!ignore && setSetList)
        }

        return () => {
            ignore = true;
        }
    }, [devMode, setList])

    return (
        <div className='sets-prev'>
            <div className='content'>
                {
                    setList ?
                        setList.length ?
                            // TODO
                            <div style={{ "--bg": "#222" }} >
                                <div className='flex side-scroll hid-scroll' style={{ padding: "0 20px", gap: "20px" }}>
                                    {/* <p>You have sets</p> */}

                                    {
                                        setList.map(item => {
                                            return <SetsItem key={item.id} name={item.name} size={item.size} />
                                        })
                                    }

                                </div>
                            </div>

                            :
                            <div className='abs-mid center-text'>
                                <p>Click here to create your first flashcard set</p>
                                <Button className="margin">Create Set</Button>
                            </div>
                        :
                        setList === undefined ?
                            <i className='fa-solid fa-spinner fa-spin'></i>
                            :
                            // show reload option
                            <p>
                                <Button onClick={reload}> Reload </Button>
                            </p>
                }
            </div>
        </div>
    )


    function fetchEm() {
        return fetch(`${Host}/api/sets`)
    }

    function reload() {
        fetchEm()
            .then(res => res.json(), err => {
                console.error(err)
                setSetList(false)
            })
            .then(setSetList)
    }
}

function SetsItem({ name, size }) {
    const nameRef = useRef();


    useEffect(() => {
        // check if useref has scroll bar
        nameRef.current.classList.add("trim");
    }, [])

    return (
        <div className="set-item br-5">
            <div className="max" ref={nameRef} style={{ fontSize: "120%", overflow: "hidden" }}> {name} </div>
            <small className="abs" style={{ bottom: "10px" }}> {size} cards </small>
        </div>
    )
}


// QUIZ PREVIEW
const quizDevData = [
    {
        id: "jbdvs",
        title: "Human  Evolution",
        size: 40,
        duration: 20
    },
    {
        id: "dknv",
        title: "Organic Chemistry",
        size: 10,
        duration: 2
    },
    {
        id: "lskdnvaskd",
        title: "Electric n Magnetic Feilds",
        size: 100,
        duration: 60
    }
]

function QuizzesPrev() {
    // can be a list (empty or not), undefined (loading), false(needs retrying)
    const [quizList, setQuizList] = useState();

    const devMode = useContext(DevMode);


    useEffect(() => {
        let ignore = false;

        if (devMode) {
            setQuizList(quizDevData)

        } else {
            !quizList && fetchEm()
                .then(res => res.json(), err => {
                    console.error(err)
                    !ignore && setQuizList(false)
                })
                .then(!ignore && setQuizList)
        }

        return () => {
            ignore = true;
        }
    }, [devMode, quizList])

    return (
        <div className='quiz-prev'>
            <div className='content'>
                {
                    quizList ?
                        quizList.length ?
                            // TODO
                            <div className='par-scroll' style={{ "--bg": "#222" }}>
                                <div className='flex side-scroll hid-scroll' style={{ padding: "0 20px", gap: "20px" }}>
                                    {
                                        quizList.map(item => {
                                            return <QuizItem key={item.id} name={item.name} size={item.size} duration={item.duration} />
                                        })
                                    }

                                </div>
                            </div>

                            :
                            <div className='abs-mid center-text'>
                                <p>Click here to create your first Quiz</p>
                                <Button className="margin">Create Quiz</Button>
                            </div>
                        :
                        quizList === undefined ?
                            <i className='fa-solid fa-spinner fa-spin'></i>
                            :
                            // show reload option
                            <p>
                                <Button onClick={reload}> Reload </Button>
                            </p>
                }
            </div>
        </div>
    )


    function fetchEm() {
        return fetch(`${Host}/api/quizes`)
    }

    function reload() {
        fetchEm()
            .then(res => res.json(), err => {
                console.error(err)
                setQuizList(false)
            })
            .then(setQuizList)
    }
}

function QuizItem({ name, duration, size }) {

    return (
        <div className="quiz-item br-5">
            <div className="max" style={{ fontSize: "120%" }}> {name} </div>
            <small className="flex fw" style={{ bottom: "20px", justifyContent: "space-between" }}>
                <span> {size} questions </span>
                <span> {duration} minutes </span>
            </small>
        </div>
    )
}


function CreateButton() {
    const [open, setOpen] = useState(false);
    const openOverlay = useContext(ToggleOverlay).open;

    return (
        <div className="cre8 fw">
            <Button className="br-1 flex mid-align margin" onClick={handleClick} style={{ padding: "2px 10px 2px 2px", gap: "10px" }}>
                <i className={`fa-solid fa-xmark ${open ? "" : "plus"}`}></i>
                Create
            </Button>
            <div className={`abs flex mid-align ${open ? '' : "close"}`}>
                <Button onClick={createFlash}> FlashCard </Button>
                <Button onClick={createQuiz}> Quiz </Button>
                <Button onClick={loadDeck}> LoadDeck </Button>
            </div>
        </div>
    )

    function handleClick() {
        setOpen(!open)
    }

    function createFlash() {
        openOverlay("create-set");
    }

    function loadDeck() {
        openOverlay('flashdeck', 7);
    }

    function createQuiz() {
        openOverlay("quiz");
    }
}